export default {
      id: "phone-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.159f8dce.svg#phone",
      toString: function () {
        return this.url;
      }
    }